export function locationToString(location: Location) {
  const searchParamsString = location.search ? `?${location.search}` : '';

  return `${location.pathname}${searchParamsString}${location.hash}`;
}
